var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "scrolled-table",
      class: {
        "scrolled-table--scroll": _vm.hasScroll,
        "scrolled-table--start": _vm.start,
        "scrolled-table--end": _vm.end,
        "scrolled-table--fix-first": _vm.fixFirst,
        "scrolled-table--fix-last": _vm.fixLast,
        "scrolled-table--bottom-fixed": _vm.bottomFixed,
      },
    },
    [
      _c("div", { ref: "topObserver", staticClass: "top-observer" }),
      _c("div", { staticClass: "scrolled-table__left" }),
      _c(
        "perfect-scrollbar",
        {
          ref: "scroll",
          staticClass: "scrolled-table__scroll",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "div",
            { ref: "container", staticClass: "scrolled-table__container" },
            [_vm._t("default")],
            2
          ),
          _vm.bottomFixed
            ? _c("div", { ref: "bottomHide", staticClass: "bottom-shadow" })
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "scrolled-table__right" }),
      _c("div", { ref: "bottomObserver", staticClass: "bottom-observer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }